import './CounterLabel-948e9882.css';

var classes = {"CounterLabel":"prc-CounterLabel-CounterLabel-ZwXPe"};

export { classes as default };
